import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { TokenStorageService } from '../../auth/services/token-storage.service';
import { InstituteService } from '../../services/institute.service';
import { InstituteType } from '../../models/institute.model';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, MatListModule, MatIconModule, MatExpansionModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit {
  private tokenStorage = inject(TokenStorageService);
  private instituteService = inject(InstituteService);

  isAdmin = signal(false);
  isCloudCampus = signal(false);

  ngOnInit(): void {
    const authorities = this.tokenStorage.getAuthorities();
    this.isAdmin.set(!authorities.includes('ROLE_Teacher'));

    this.instituteService.getDefaultInstitute().subscribe(data => {
      this.isCloudCampus.set(data?.type === InstituteType.CLOUD_CAMPUS);
    });
  }
}
